import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Answer } from '../../../../../models/suitability/answer';
import { Question } from '../../../../../models/suitability/question';
import { ReactiveControlValidator } from '../../../../../abstration/control-validator';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { get } from 'lodash';

@Component({
  selector: 'app-radio-question',
  templateUrl: './radio-question.component.html',
  styleUrls: ['./radio-question.component.scss']
})
export class RadioQuestionComponent
  extends ReactiveControlValidator
  implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() answerses: Answer[];
  @Input() value?: Question;
  @Input() disabled = false;
  @Input() showUserAnswer: boolean;

  @Output() onAnswerClick = new EventEmitter<Question>();

  formControl: FormControl;

  constructor(protected formBuilder: FormBuilder) {
    super(formBuilder);
  }

  ngOnInit() {}

  ngOnChanges() {
    this.formControl = this.formBuilder.control(
      { value: '', disabled: this.disabled },
      Validators.required
    );

    this.formControl.setValue(get(this.value, 'answer.id', null));
  }

  initReactiveForms() {}

  onAnswerRadioClick(answer: Answer) {
    this.onAnswerClick.emit({ id: this.id, answer });
  }
}
